module.exports = new __parcel__URL__("the-terminator.c42d5991.jpg").toString();